// extracted by mini-css-extract-plugin
export var root = "Breadcrumbs-module--root--BmTza";
export var sep = "Breadcrumbs-module--sep--PTVSi";